import { useMutation, UseMutationResult } from 'react-query'
import { errorAlert, loadingAlert, successAlert } from '../../../../utils/alert'
import { api } from '../../../api'
import { localConfig } from '../../../../Configs/localConfig'

interface PropsAtribuicao {
    cod_usuario: number
    veiculos: number[]
    refetch: () => void
}

export const usePostAtribuicao = (): {
    carregando_salvar_atribuicao: boolean
    mutate_atribuicao: (params: PropsAtribuicao) => void
    isSuccess_atribuicao: boolean
} => {
    const mutation: UseMutationResult<Response, Error, PropsAtribuicao> = useMutation(
        async (params: PropsAtribuicao) => {
            const { cod_usuario, veiculos, refetch } = params

            loadingAlert({ msg: 'Salvando...', id: 'loading' })

            return api
                .post(
                    `/usuario/veiculo?codConta=${localConfig()?.conta}&codCliente=${localConfig()?.codCliente
                    }`,
                    {
                        cod_usuario,
                        veiculos,
                    }
                )
                .then((response: any) => {
                    successAlert('Atribuição atribuído com sucesso!', 5000, 'loading')
                    refetch?.()
                    return response
                })
                .catch((error: any) => {
                    if (error?.response?.data?.error[0]?.msg) {
                        error.response.data.error.forEach((data) => {
                            errorAlert(data?.msg[0] ?? 'Falha ao salvar atribuição!', 5000, 'loading')
                        })
                    } else {
                        errorAlert(error.response.data.error ?? 'Falha ao salvar atribuição!', 5000, 'loading')
                    }

                    throw error
                })
        }
    )

    return {
        carregando_salvar_atribuicao: mutation.isLoading,
        mutate_atribuicao: mutation.mutate,
        isSuccess_atribuicao: mutation.isSuccess,
    }
}